import { render, staticRenderFns } from "./CategoryTree.vue?vue&type=template&id=2516547e&scoped=true"
import script from "./CategoryTree.vue?vue&type=script&lang=js"
export * from "./CategoryTree.vue?vue&type=script&lang=js"
import style0 from "./CategoryTree.vue?vue&type=style&index=0&id=2516547e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2516547e",
  null
  
)

export default component.exports